import { useQuery } from "@apollo/client";

import { ProjectDeliverablesScreen_GetFilterOptionsDocument } from "./queries.generated";

export function useProjectDeliverablesFilterOptions(projectId: string) {
    const { data, loading, error } = useQuery(ProjectDeliverablesScreen_GetFilterOptionsDocument, {
        variables: { projectId },
    });

    return {
        researchTypes: data?.settingsResearchTypeGetAutocompleteOptions?.data ?? [],
        plannerAreas: data?.plannerV2AreaGetAllByProjectId?.data ?? [],
        loading,
        error,
    };
}
